module.exports = __webpack_public_path__ + "static/media/arts.e1ecd7df.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/assets/images/teachers/noticeboard/arts.svg
// module id = 561
// module chunks = 0